import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  //To list category

  getCatrogyList(body: any) {

    const link = this.apiUrl + ApiUrls.categoryGetList;
    return this.http.post(link, body);
  }


  //To create category
  createCategory(body: any) {
    const link = this.apiUrl + ApiUrls.createCategory;
    return this.http.post<any>(link, body);
  }

  //To get Category by Id
  getCategoryById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.categoryById}/${id}`;
    return this.http.get<any>(link);
  }

  //To update category
  updateCategory(id: number, body: any) {
    const link = `${this.apiUrl}${ApiUrls.updateCategory}/${id}`;
    return this.http.post<any>(link, body);
  }

  //To delete category
  deleteCategory(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteCategory}/${id}`;
    return this.http.post<any>(link, id);

  }

  //To list workflow group

  workflowGroupList(body: any) {

    const link = this.apiUrl + ApiUrls.workflowGroupList;
    return this.http.post(link, body);
  }

  //To create workflow group
  createWorkflowGroup(body: any) {
    const link = this.apiUrl + ApiUrls.createWorkflowGroup;
    return this.http.post<any>(link, body);
  }

  //To update workflow group
  updateWorkflowGroup(id: number, body: any) {
    const link = `${this.apiUrl}${ApiUrls.updateWorkflowGroup}/${id}`;
    return this.http.post<any>(link, body);
  }

  //To get workflow group by id
  getWorkflowGroupById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.getWorkFlowGroupById}/${id}`;
    return this.http.get<any>(link);
  }


  //To list Workflow
  workflowList(body: any) {

    const link = this.apiUrl + ApiUrls.workFlowList;
    return this.http.post(link, body);
  }

  //To get workflow details group list
  getWorkflowDeatilsGroupList() {
    const link = `${this.apiUrl}${ApiUrls.workflowDetailsGroupList}`;
    return this.http.get<any>(link);
  }

  //To delete workflow groups
  deleteWorkflowGroup(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteWorkflowGroup}/${id}`;
    return this.http.post<any>(link, id);
  }

  //To get workflow details category list
  getWorkflowDeatilsCategoryList() {
    const link = `${this.apiUrl}${ApiUrls.workflowDetailsCategoryList}`;
    return this.http.get<any>(link);
  }

  //To get workflow details by id
  getWorkflowetailsById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.worflowDetailsGetById}/${id}`;
    return this.http.get<any>(link);
  }

  //To create workflow details
  createFlowDeatils(body: any) {
    const link = this.apiUrl + ApiUrls.createWorkflowDetails;
    return this.http.post<any>(link, body);
  }

  //To update workflow details
  updateWorkflowDetails(id: number, body: any) {
    const link = `${this.apiUrl}${ApiUrls.updateWorkflowDeatils}/${id}`;
    return this.http.post<any>(link, body);
  }

  //To delete workflow details
  deleteWorkflow(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteWorkflowDetails}/${id}`;
    return this.http.post<any>(link, id);
  }

}
